import script from './basic-date-table.vue_vue_type_script_lang.mjs';
export { default } from './basic-date-table.vue_vue_type_script_lang.mjs';
import { render } from './basic-date-table.vue_vue_type_template_id_0572814e_lang.mjs';

script.render = render;
script.__file = "packages/components/date-picker/src/date-picker-com/basic-date-table.vue";
//# sourceMappingURL=basic-date-table.mjs.map
